export const LOCAL_STORAGE_KEYS = {
  campaignLinkToken: 'campaignLinkToken',
};
